export const unitTypeColors: Record<string, string> = {
	video: '#6C63FF',
	document: '#FF8532',
	test: '#FFD037',
	webinar: '#A0A2FF',
	webcontent: '#36A2EB',
	assignment: '#00CE67',
	total: '#5AC0FC',
};
